<script setup lang="ts">
/**
 * Empty Dark Layout
 * --------------------------------------------------------------------------------------------------
 * Layout used for splash pages
 */
</script>

<template>
    <div>
        <TheBaseLayout body-classes="bg-brand-b!">
            <div class="relative h-full">
                <TheLogo />
                <NuxtPage />
            </div>
        </TheBaseLayout>
    </div>
</template>
